import {Form, type FormData} from "@/types/permissions/forms";
import {ListingFilter, type ListingFilterData} from "@/types/permissions/listing-filters";
import {ListingAction, type ListingActionData} from "@/types/permissions/listing-actions";

export class Listing {
    public id: number | null;
    public klg_permission_page_id: number | null;
    public client_permission_page_id: number | null;
    public form_id: number;
    public form: Form | undefined;
    public listingFilters: ListingFilter[];
    public listingActions: ListingAction[];

    constructor(data: ListingData | void) {
        if (data === undefined) {
            this.id = null;
            this.klg_permission_page_id = null;
            this.client_permission_page_id = null;
            this.form_id = -1;
            this.form = undefined;
            this.listingFilters = [];
            this.listingActions = [];

        } else {
            this.id = data.id;
            this.klg_permission_page_id = data.klg_permission_page_id;
            this.client_permission_page_id = data.client_permission_page_id;
            this.form_id = data.form_id;
            if (data.form !== undefined) {
                this.form = new Form(data.form);
            } else {
                this.form = undefined;
            }
            this.listingFilters = [];
            if (data.listingFilters !== undefined) {
                data.listingFilters.forEach(listingFilters => this.listingFilters.push((new ListingFilter(listingFilters))));
            }
            this.listingActions = [];
            if (data.listingActions !== undefined) {
                data.listingActions.forEach(listingActions => this.listingActions.push((new ListingAction(listingActions))));
            }
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.klg_permission_page_id = null;
        this.client_permission_page_id = null;
        this.form_id = -1;
        this.listingFilters = [];
        this.listingActions = [];

    }
}

export type ListingData = {
    id: number | null;
    klg_permission_page_id: number | null;
    client_permission_page_id: number | null;
    form_id: number;
    form: FormData | undefined;
    listingFilters: ListingFilterData [] | undefined;
    listingActions: ListingActionData [] | undefined;

}